import { render, staticRenderFns } from "./SBtn.vue?vue&type=template&id=2fbcb4de&"
import script from "./SBtn.vue?vue&type=script&lang=js&"
export * from "./SBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports